// Module
var code = "<page-header title=\"'设置'\" breadcrumbs=\"[{label:'设置', link:'portainer.settings'}, '边缘计算']\" reload=\"true\"> </page-header>\n\n<div class=\"row\">\n  <div class=\"col-sm-12\" ng-if=\"$ctrl.settings\">\n    <settings-edge-compute on-submit=\"($ctrl.onSubmitEdgeCompute)\" settings=\"($ctrl.settings)\"></settings-edge-compute>\n  </div>\n</div>\n";
// Exports
var _module_exports = code;;
var path = 'app/portainer/views/settings/edge-compute/settingsEdgeCompute.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;